import { render } from "./toggle-theme.vue?vue&type=template&id=dfc6c154"
import script from "./toggle-theme.vue?vue&type=script&lang=js"
export * from "./toggle-theme.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__